import { render } from "./Tab5Form.vue?vue&type=template&id=ec40ddf6"
import script from "./Tab5Form.vue?vue&type=script&lang=js"
export * from "./Tab5Form.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__